import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { App } from './app';

import reportWebVitals from './reportWebVitals';
import '../src/styles/index.scss';

if (typeof window !== 'undefined' && typeof Node !== 'undefined' && !window.__DOM_TRANSLATE_PATCHED__) {
  window.__DOM_TRANSLATE_PATCHED__ = true;

  const rawRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function patchedRemoveChild(child) {
    try {
     return rawRemoveChild.call(this, child);
   } catch (error) {
     if (error?.name === 'NotFoundError') {
       return child;
     } 
     throw error;
   }
 };

  const rawInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function patchedInsertBefore(newNode, referenceNode) {
     if (referenceNode && referenceNode.parentNode !== this) {
      return this.appendChild(newNode);
    }
    try {
      return rawInsertBefore.call(this, newNode, referenceNode);
    } catch (error) {
      if (error?.name === 'NotFoundError') {
        return this.appendChild(newNode);
      }
      throw error;
    }
  };
}


const container = document.getElementById('root');
const root = createRoot(container); // ✅ Correct usage
/* eslint-disable comma-dangle */
root.render(
  <I18nextProvider i18n={i18n}>
    <Suspense fallback={null}>
      <App />
    </Suspense>
  </I18nextProvider>
);

// Optionally report performance metrics
reportWebVitals();
